import { Building2 } from "lucide-react";

export default function DepartmentSelectionRequired({ message }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        height: "100%",
        padding: "40px 24px",
        textAlign: "center",
        background: "#ffffff",
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: 20,
          background: "linear-gradient(135deg, #fbbf24 0%, #d97706 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 20,
          boxShadow: "0 8px 24px rgba(217, 119, 6, 0.2)",
        }}
      >
        <Building2 size={28} color="#fff" />
      </div>
      <h3
        style={{
          fontSize: 18,
          fontWeight: 700,
          color: "#1e293b",
          marginBottom: 8,
        }}
      >
        Department Selection Required
      </h3>
      <p
        style={{
          fontSize: 13,
          color: "#64748b",
          maxWidth: 360,
          lineHeight: 1.6,
        }}
      >
        {message}
      </p>
    </div>
  );
}
